import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { _className } from '../../utils/tools.js';
import './TS_Card.scss';
import { TS_ErrorBoundary } from '../TS_ErrorBoundary/index.js';
export class TS_Card extends React.Component {
    shouldComponentUpdate() {
        return true;
    }
    render() {
        const { children, className, innerRef, ...rest } = this.props;
        return _jsx("div", { ...rest, className: _className('ts-card', className), children: _jsx(TS_ErrorBoundary, { children: children }) });
    }
}
//# sourceMappingURL=TS_Card.js.map